import React from 'react'
import { useAppDispatch } from 'reduxTyped'
import { l, Radio, RadioGroup } from '@manychat/manyui'

import { updateBlock } from 'common/builder/actions/updateBlock'
import { ButtonStyle } from 'common/builder/constants/ButtonStyle'

interface ButtonStyleRadioProps {
  builderId: string
  blockId: string
  value: ButtonStyle
}

export const ButtonStyleRadio = ({ builderId, blockId, value }: ButtonStyleRadioProps) => {
  const dispatch = useAppDispatch()

  const handleChange = (newValue: string) => {
    dispatch(
      updateBlock(builderId, blockId, {
        buttonsStyle: newValue,
      }),
    )
  }

  return (
    <>
      <label className="form-label">{l.translate('Button type')}</label>
      <div className="text-secondary text-sm m-b-sm">
        {l.translate('Will apply to all buttons in the message')}
      </div>
      <RadioGroup name="buttonsStyle" value={value} onChange={handleChange}>
        <Radio value={ButtonStyle.SOLID} label={l.translate('Solid')} name="buttonsStyle" />
        <Radio value={ButtonStyle.TEXT} label={l.translate('Text')} name="buttonsStyle" />
      </RadioGroup>
    </>
  )
}
